export * from './vorlage-kopiert.interface';
